export type RenderMode = 'html' | 'plaintext'

const ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
}

export function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (c) => ESCAPE_MAP[c])
}

/**
 * Substitute `{KEY}` tokens in `template` and HTML-escape every value before
 * insertion. Missing tokens collapse to empty string — this is load-bearing
 * for the Bison custom-variable indirection: an override body that literally
 * contains `{CUSTOM_BODY_S42}` must not pass the placeholder through, because
 * the rendered output becomes the value of `custom_body_s42` and Bison would
 * re-expand the token, creating circular resolution. Warning detection runs
 * on a separate non-escaping `fillVariables` pass instead.
 * Lookup is case-insensitive. Mirrors `server/emailbison/rendering/render.py:interpolate_variables`.
 *
 * Values are escaped because the body is Quill-produced HTML processed as
 * HTML downstream — an unescaped `<` or `>` would be eaten by the parser.
 */
export function interpolateVariables(
  template: string,
  tokens: Record<string, string>
): string {
  return template.replace(
    /\{([A-Za-z_][A-Za-z0-9_]*)\}/g,
    (_match, key: string) => escapeHtml(tokens[key.toUpperCase()] ?? '')
  )
}
